import { useLocation } from "react-router-dom";

export const useTemplateDataGridVisibility = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const isNotSmallScreen = window.matchMedia("(min-width: 768px)").matches;
    return params.has("data") && isNotSmallScreen;
};
